import {
    Badge,
    Box,
    Button,
    Flex,
    Grid,
    Group,
    Input,
    Menu,
    MultiSelect,
    MultiSelectProps,
    rem,
    Select,
    Text,
} from "@mantine/core";
import {
    IconBarcode,
    IconBuildingWarehouse,
    IconCaretDown,
    IconFileExport,
    IconMapPin,
    IconSearch,
    IconTimeDuration15,
    IconX,
} from "@tabler/icons-react";
import {
    MRT_ColumnDef,
    MRT_PaginationState,
    MRT_RowSelectionState,
    MantineReactTable,
    useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { useForm } from "@mantine/form";
import { useDebouncedCallback, useDisclosure } from "@mantine/hooks";
import { SelectListItemModel } from "../../../../model/SelectListItem";
import { BASE_API_MDM } from "../../../../config";
import { green } from "../../../../const/variables";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import {
    repositoryMdm,
    repositoryPos,
    styleTableMantine,
} from "../../../../_base/_const/_constVar";
import { _localization } from "../../../../config/location";
import LoadingOverlayCustom from "../../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import {
    formatDateNotTimeZone,
    formatDateTransfer,
    formatDateTransferLastYear,
    formatToReverseDate,
} from "../../../../common/FormatDate/FormatDate";
import { DatePickerInput } from "@mantine/dates";

interface SearchCriteria {
    keySearch?: string;
    branchCode?: string[]; // Mảng chứa các mã chi nhánh
    invCode?: string[]; // Mảng chứa các mã kho
    itemCode?: string[]; // Mảng chứa các mã sản phẩm
    itemKey?: string; // Mã sản phẩm hoặc khóa sản phẩm
    MaNganh?: string;
    MaLoai?: string;
    MaNhom?: string;
    MaHangSx?: string;
    FromDate?: Date | string;
    ToDate?: Date | string;
    FromTuoiTon?: number;
    ToTuoiTon?: number;
}

const InventoryAgeItem = () => {
    // Khởi tạo component InventoryReportList
    const headerRef = React.useRef<HTMLDivElement>(null);
    const [isRefetching, setIsRefetching] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [pagination, setPagination] = useState<MRT_PaginationState>({
        pageIndex: 0,
        pageSize: 20,
    });
    const [visible, { toggle, close, open }] = useDisclosure(false);

    const [height, setHeight] = useState(0);
    const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
    const [data, setData] = useState<InventoryItem[]>([]);
    const [dataInvCode, setDataInvCode] = useState<SelectListItemModel[]>([]);
    const [dataItemCode, setDataItemCode] = useState<SelectListItemModel[]>([]);
    const [rowCount, setRowCount] = useState(0);

    const form = useForm<SearchCriteria>({
        mode: "uncontrolled",
        initialValues: {},
    });

    type InventoryItem = {
        branchCode: string;
        branchName: string;
        countSoLuong: number;
        dvt: string | null;
        idBranch: number;
        idKho: number;
        maKho: string;
        maSp: string;
        soLuong: number | null;
        tenKho: string;
        tenSp: string;
    };

    const columns = React.useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                header: "STT",
                accessorKey: "STT",
                enableColumnActions: false,
                enableSorting: false,
                enableResizing: false,
                Cell: ({ row }) => <>{row?.index + 1}</>,
                size: 50,
            },
            {
                accessorKey: "tenBaoCao",
                header: "Tên báo cáo",
                size: 250,
            },
            {
                accessorKey: "giaTriTon",
                header: "Giá trị tồn",
                Cell: ({ renderedCellValue }) => (
                    <>
                        {Number(renderedCellValue).toLocaleString("vi-VN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}
                    </>
                ),
            },
            {
                accessorKey: "soLuongTon",
                header: "Số lượng tồn",
                Cell: ({ renderedCellValue }) => (
                    <>
                        {Number(renderedCellValue).toLocaleString("vi-VN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}
                    </>
                ),
            },
            {
                accessorKey: "tyTrong",
                header: "Tỷ trọng",
                Cell: ({ renderedCellValue, cell, row }) => <>{renderedCellValue} %</>,
            },
        ],
        []
    );
    const exportDataExcel = async () => {
        open();
        try {
            let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;
            const search = form.getValues();
            if (search.branchCode && search.branchCode.length > 0) {
                url += `&MaCn=${search.branchCode}`;
            }
            if (search.invCode) {
                url += `&MaKho=${search.invCode}`;
            }
            if (search.itemCode) {
                url += `&MaSp=${search.itemCode}`;
            }

            if (search.keySearch) {
                url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
            }
            const baseUrl = `/api/v1/ExportExcel/export-bao-cao-tuoi-ton-theo-hang-hoa${url}`;

            const _url = BASE_API_MDM + baseUrl;
            const token = localStorage.getItem("token");

            const response = await fetch(_url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/vnd.ms-excel",
                    Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
                },
            });
            // Kiểm tra trạng thái HTTP
            if (!response.ok) {
                const errorResponse = await response.json(); // Parse lỗi từ API
                const errorMessage =
                    errorResponse?.message || "Đã xảy ra lỗi khi xuất dữ liệu!";
                throw new Error(errorMessage); // Ném lỗi để xử lý trong `catch`
            }

            const blob = await response.blob();
            const urlss = window.URL.createObjectURL(blob);
            const _name = new Date().toISOString().slice(0, 10);
            let filename = "bao_cao_tuoi_ton_theo_hang_hoa.xlsx";
            const link = document.createElement("a");
            link.href = urlss;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error: any) {
            console.log("error", error);
            // Hiển thị thông báo lỗi
            NotificationExtension.Fails(
                error.message || "Đã xảy ra lỗi không xác định!"
            );
        } finally {
            close();
        }
    };
    // Hàm lấy dữ liệu
    const fetchData = async () => {
        setIsLoading(true);
        setIsRefetching(true);
        setIsError(false);

        let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${pagination.pageSize
            }`;
        const search = form.getValues();

        if (search.branchCode && search.branchCode.length > 0) {
            url += `&MaCn=${search.branchCode}`;
        }
        if (search.invCode) {
            url += `&MaKho=${search.invCode}`;
        }
        if (search.itemCode) {
            url += `&MaSp=${search.itemCode}`;
        }

        if (search.keySearch) {
            url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
        }
        try {
            const response = await repositoryMdm.get(
                `/api/v1/BaoCaoTuoiTonTheoHangHoa/get-list${url}`
            );
            if (response && response.success) {
                let result = response.data;
                setData(result);
                setRowCount(response.totalCount);
                table.resetRowSelection();
            } else {
                setData([]);
                setRowCount(response.totalCount);
            }
        } catch (error) {
            setData([]);
            setIsError(true);
            console.error(error);
            return;
        } finally {
            setIsLoading(false);
            setIsRefetching(false);
        }
    };

    const DataInvCode = async () => {
        try {
            const response = await repositoryPos.get(
                `/api/v1/TblDmInventory/get-all?checkAuth=true&select=true`
            );
            if (response && response.success) {
                const transformedData = response.data
                    ?.filter((i: any) => i.value && i.text && i.value !== "-1")
                    ?.map((item: any) => ({
                        label: item.text?.toString(),
                        value: item.att1?.toString(),
                    }));

                setDataInvCode(transformedData);
            }
        } catch (error) {
            console.error(error);
            return;
        }
    };
    const DataItemCode = async (keySearch: string) => {
        try {
            let url = "";
            if (keySearch && keySearch.length > 0) {
                url += `&ItemCodes=${keySearch}`;
            }
            const response = await repositoryPos.get(
                `/api/v1/TblItem/get-select?Key=${keySearch}&Page=30`
            );
            if (response && response.success) {
                const transformedData = response.data
                    ?.filter((i: any) => i.value && i.text)
                    .map((branch: any) => ({
                        value: branch.value,
                        label: branch.text,
                    }));
                const uniqueData = Array.from(
                    new Set(transformedData.map((item: any) => item.value))
                ).map((value) =>
                    transformedData.find((item: any) => item.value === value)
                );
                setDataItemCode(uniqueData);
            }
        } catch (error) {
            console.error(error);
            return;
        }
    };

    const table = useMantineReactTable({
        columns,
        data,
        enableColumnResizing: true,
        rowCount,
        enableColumnFilters: true,
        enableSorting: true,
        enableColumnActions: true,
        // manualPagination: true,
        enableStickyFooter: true,
        state: {
            // columnFilters,
            // globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            showSkeletons: isLoading,
            rowSelection,
        },
        manualFiltering: false,
        manualPagination: true,
        manualSorting: false,
        onPaginationChange: setPagination,
        positionToolbarAlertBanner: "bottom",
        initialState: {
            showColumnFilters: false,
            columnPinning: {
                left: ["STT", "maSp", "transactionNumber", "sourceCode"],
                right: [
                    "statusName",
                    "countSoLuong",
                    "countSlChoXuat",
                    "countSlChoNhap",
                ],
            },
            columnVisibility: { id: false },
            density: "xs",
        },
        enableTopToolbar: false,
        mantineTopToolbarProps: {
            style: {
                borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
                marginBottom: 5,
            },
        },
        localization: _localization,
        getRowId: (row) => row.departmentId,
        mantineTableContainerProps: {
            style: { maxHeight: height, minHeight: height },
        },
        enableStickyHeader: true,
        onRowSelectionChange: setRowSelection,
        mantineTableBodyCellProps: ({ row }) => ({
            style: styleTableMantine,
        }),
        mantineToolbarAlertBannerProps: false
            ? { color: "red", children: "Lỗi tải dữ liệu !" }
            : undefined,

        mantinePaginationProps: {
            showRowsPerPage: true,
            withEdges: true,
            radius: "xl",
            size: "lg",
            rowsPerPageOptions: ["20", "50", "100"],
        },
        paginationDisplayMode: "pages",
        enableColumnPinning: true,
        mantineTableProps: {
            striped: false,
        },
        mantineTableBodyRowProps: ({ row }) => ({
            onClick: row.getToggleSelectedHandler(),
            sx: { cursor: "pointer" },
        }),
    });
    useEffect(() => {
        const headerHeight = headerRef.current?.offsetHeight || 0;
        const handleResize = () => {
            setHeight(window.innerHeight - (165 + headerHeight));
        };

        handleResize(); // Set initial height
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [height]);
    useEffect(() => {
        fetchData();
    }, [pagination]);
    const renderMultiSelectOption: MultiSelectProps["renderOption"] = ({
        option,
    }) => (
        <Group gap="sm">
            <Text>{dataItemCode.find((x) => x.value === option.value)?.label}</Text>
        </Group>
    );
    // Sử dụng debounce để trì hoãn việc gọi API
    const debouncedDataItemCode = useDebouncedCallback((value: string) => {
        if (value.length >= 3) {
            DataItemCode(value); // Gọi API với từ khóa tìm kiếm
        }
    }, 500);
    return (
        <Box>
            <LoadingOverlayCustom visible={visible} />
            <div ref={headerRef} style={{ width: "100%", marginBottom: "10px" }}>
                <Flex justify={"space-between"} w={"100%"}>
                    <_breadcrumb></_breadcrumb>
                    <Button
                        leftSection={
                            <IconFileExport style={{ width: rem(14), height: rem(14) }} />
                        }
                        onClick={() => exportDataExcel()}
                    >
                        Export Excel
                    </Button>
                </Flex>
                <Grid>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Input
                            placeholder="Nhập tìm kiếm"
                            key={form.key("keySearch")}
                            type="text"
                            leftSection={<IconSearch size={"20"} color="#15aabf" />}
                            onKeyDown={async (e) => {
                                if (e.key === "Enter") {
                                    await fetchData();
                                }
                            }}
                            {...form.getInputProps("keySearch")}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Select
                            key={form.key("itemCode")}
                            size="sm"
                            placeholder="Mã sản phẩm"
                            clearable
                            searchable
                            data={dataItemCode.map((x) => x.value)} // Hiển thị kết quả từ API
                            //   value={search.itemCode}
                            renderOption={renderMultiSelectOption}
                            leftSection={<IconBarcode size={20} color="#15aabf" />}
                            // onSearchChange={(value) => {
                            //   if (value.length >= 3) {
                            //     DataItemCode(value); // Gọi API với từ khóa tìm kiếm
                            //   }
                            // }}
                            onSearchChange={(value) => {
                                debouncedDataItemCode(value); // Sử dụng debounce
                            }}
                            // onChange={(value) => {
                            //   handleChangeSearchValue(value, "itemCode");
                            // }}
                            {...form.getInputProps("itemCode")}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Button
                            color="blue"
                            variant="outline"
                            onClick={async () => {
                                await fetchData();
                            }}
                        >
                            Tìm kiếm
                        </Button>
                    </Grid.Col>
                </Grid>
            </div>
            <MantineReactTable table={table} />
        </Box>
    );
};

export default InventoryAgeItem;
